import React, { useEffect, useState, useMemo } from "react";
import styles from "@/components/CustomComponents/ProToolBox/index.module.scss";
import ToolCard from "@/components/CustomComponents/ProToolBox/Card";

const ProToolBox = fields => {
  const { toolBoxData } = fields || {};
  if (!toolBoxData) return null;
  const { heading = "", cards = [] } = toolBoxData;
  return (
    <div className={styles.wrapper}>
      <div className="px-3">
        <div className="articleContent">
          {heading ? (
            <p className="koh-pro-toolbox-title text-xl md:text-3xl text-[#000]">
              {heading}
            </p>
          ) : null}
        </div>
        {cards.map((imageData, index) => (
          <ToolCard key={index} {...imageData} />
        ))}
        <hr className=" flex-grow line" />
      </div>
    </div>
  );
};

export default ProToolBox;
